import { apiKeyURL } from "../../App"

function base64Encode(uint8Array) {
  return btoa(String.fromCharCode(...uint8Array))
}

function base64Decode(base64) {
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))
}

export async function encrypt(text) {
  try {
    const key = apiKeyURL
    const iv = key

    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      new TextEncoder().encode(key),
      { name: "AES-CBC" },
      false,
      ["encrypt"]
    )

    const encodedText = new TextEncoder().encode(text)

    const encryptedBuffer = await window.crypto.subtle.encrypt(
      { name: "AES-CBC", iv: new TextEncoder().encode(iv) },
      cryptoKey,
      encodedText
    )

    return base64Encode(new Uint8Array(encryptedBuffer))
  } catch (error) {
    console.error("Encryption failed:", error)
    return null
  }
}

export async function decrypt(encryptedBase64) {
  try {
    if (!encryptedBase64) return null

    const key = apiKeyURL
    const iv = key

    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      new TextEncoder().encode(key),
      { name: "AES-CBC" },
      false,
      ["decrypt"]
    )

    const encryptedBytes = base64Decode(encryptedBase64)

    const decryptedBuffer = await window.crypto.subtle.decrypt(
      { name: "AES-CBC", iv: new TextEncoder().encode(iv) },
      cryptoKey,
      encryptedBytes
    )

    return new TextDecoder().decode(decryptedBuffer)
  } catch (error) {
    console.error("Decryption failed:", error)
    return null
  }
}
